 import { useEffect, useState } from 'react';

const usePreviousSearchText = (searchText) => {
    const [previousSearchText, setPreviousSearchText] = useState('');

    useEffect(() => {
        if (searchText?.length < 2) {
          setPreviousSearchText('')
        }
    }, [searchText])

    return {
        previousSearchText,
        setPreviousSearchText,
    }
};

export default usePreviousSearchText;
